import backgroundImg from './assets/background.png';
import titleTextSvg from './texts/title_text.svg';
import bodyTextSvg from './texts/body_text.svg';

export const ALL_DELIVERY_COMPLETED_BACKGROUND_URL = backgroundImg;
export const ALL_DELIVERY_COMPLETED_TITLE_TEXT_URL = titleTextSvg;
export const ALL_DELIVERY_COMPLETED_BODY_TEXT_URL = bodyTextSvg;

export function getAllDeliveryCompletedAssetUrls(): string[] {
  return [backgroundImg, titleTextSvg, bodyTextSvg];
}
